/**
 * useOptionChainStore.js
 * Zustand store for Strategy Builder state.
 * Tracks which strikes are selected, per underlying+expiry session.
 */
import { create } from 'zustand';

const useOptionChainStore = create((set, get) => ({
    // Selected legs: Array of { strike, side: 'CE'|'PE', action: 'BUY'|'SELL', qty: number }
    selectedLegs: [],

    // Currently active underlying/expiry (drives the table)
    activeUnderlying: null,
    activeExpiry: null,

    setActive: (underlying, expiry) =>
        set({ activeUnderlying: underlying, activeExpiry: expiry }),

    toggleLeg: (strike, side) => {
        const { selectedLegs } = get();
        const exists = selectedLegs.find(l => l.strike === strike && l.side === side);
        if (exists) {
            set({ selectedLegs: selectedLegs.filter(l => !(l.strike === strike && l.side === side)) });
        } else {
            set({
                selectedLegs: [
                    ...selectedLegs,
                    { strike, side, action: 'BUY', qty: 1 },
                ],
            });
        }
    },

    isSelected: (strike, side) =>
        get().selectedLegs.some(l => l.strike === strike && l.side === side),

    updateLeg: (strike, side, patch) =>
        set({
            selectedLegs: get().selectedLegs.map(l =>
                l.strike === strike && l.side === side ? { ...l, ...patch } : l
            ),
        }),

    removeLeg: (strike, side) =>
        set({ selectedLegs: get().selectedLegs.filter(l => !(l.strike === strike && l.side === side)) }),

    clearLegs: () => set({ selectedLegs: [] }),
}));

export default useOptionChainStore;
